import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function resentOTP(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/resend/otp?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.RESEND_OTP_REQUEST, types.RESEND_OTP_RECEIVE,{
                type: types.RESEND_OTP_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetResentOTP = () => ({
    type: types.RESET_RESEND_OTP,
    payload: null
});